module.exports = __webpack_public_path__ + "static/media/eumodicogryllus_bordigalensis_022_APA.c8b7029e.mp3";